<template>
<div></div>
</template>

<script>
import * as THREE from 'three'

export default {
  props: {
    heightSeg: {
      default () {
        return 10
      }
    },
    widthSeg: {
      default () {
        return 10
      }
    },
    height: {
      default () {
        return 1200
      }
    },
    radius: {
      default () {
        return 400
      }
    },
    size: {
      default () {
        return window.devicePixelRatio || 1.5
      }
    },
    texture: {
      default () {
        return `
          data:image/svg+xml;utf8,
          <svg width="250px" height="250px" viewBox="0 0 250 250" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
              <desc>Created with Sketch.</desc>
              <defs>
                  <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="48.0996891%" id="radialGradient-1">
                      <stop stop-color="#FFF" stop-opacity="1.0" offset="0%"></stop>
                      <stop stop-color="#081f2c" stop-opacity="1.0" offset="75%"></stop>
                      <stop stop-color="#081f2c" stop-opacity="0" offset="100%"></stop>
                  </radialGradient>
              </defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Desktop" transform="translate(-295.000000, -163.000000)" fill="url(#radialGradient-1)">
                      <circle id="Oval" cx="420" cy="288" r="130"></circle>
                  </g>
              </g>
          </svg>
        `
      }
    }
  },
  mounted () {
    var shootingStarsField = new THREE.LineSegments()
    shootingStarsField.$skipRaycast = true

    var linesGeometry

    this.makeSpiralGeo = () => {
      linesGeometry = new THREE.BufferGeometry()
      let radius = this.radius

      var startPos = []
      var endPos = []

      var positions = []
      // var colors = []
      var randoms = []
      var tails = []

      let widthSegments = this.widthSeg
      let heightSegments = this.heightSeg

      let phiStart = 0
      let phiLength = Math.PI * 2
      let thetaStart = 0
      let thetaLength = Math.PI * 2

      widthSegments = Math.max(3, Math.floor(widthSegments) || 8)
      heightSegments = Math.max(2, Math.floor(heightSegments) || 6)

      phiStart = phiStart !== undefined ? phiStart : 0
      phiLength = phiLength !== undefined ? phiLength : Math.PI * 2

      thetaStart = thetaStart !== undefined ? thetaStart : 0
      thetaLength = thetaLength !== undefined ? thetaLength : Math.PI

      linesGeometry.extra = {
        thetaStart,
        thetaLength,
        phiStart,
        phiLength
      }
      // let thetaEnd = thetaStart + thetaLength

      let ix
      let iy

      // var color = new THREE.Color()

      let star = new THREE.Vector3()
      let star2 = new THREE.Vector3()
      let temp = new THREE.Vector3()
      star.star2 = star2
      star.temp = temp

      for (iy = 0; iy <= heightSegments; iy++) {
        // let verticesRow = []

        let v = iy / heightSegments

        for (ix = 0; ix <= widthSegments; ix++) {
          let u = ix / widthSegments

          let tt = ix * iy
          let ett = tt / (widthSegments * heightSegments)

          // let ett = iy / heightSegments

          ett = ett * 2 - 1

          star.u = u
          star.v = v

          // vertex
          // star.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength)
          // star.y = radius * Math.cos(thetaStart + v * thetaLength)
          // star.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength)

          // ribbon
          // star.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength)
          // star.y = radius * Math.tan(thetaStart + u * thetaLength)
          // star.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength)

          let rand = Math.random() * 0.9 + 0.5
          let rand2 = Math.random() * 0.9 + 0.5

          // ribbon
          star.x = -radius * rand * Math.cos(phiStart + ett * phiLength) * Math.sin(thetaStart + ett * thetaLength)

          star.y = (ett) * this.height * rand

          star.z = -radius * rand * Math.sin(phiStart + ett * phiLength) * Math.sin(thetaStart + ett * thetaLength)

          star.x = star.x + THREE.Math.randFloatSpread(star.x) * 0.5 * Math.random()
          star.y = star.y + THREE.Math.randFloatSpread(star.y) * 0.5 * Math.random()
          star.z = star.z + THREE.Math.randFloatSpread(star.z) * 0.5 * Math.random()

          temp.x = -500.0 * rand * rand2
          temp.y = 180 * rand * rand2
          temp.z = 0 * rand * rand2

          star2.x = star.x + temp.x
          star2.y = star.y + temp.y
          star2.z = star.z + temp.z

          // head
          startPos.push(star2.x)
          startPos.push(star2.y)
          startPos.push(star2.z)
          // tail
          startPos.push(star2.x)
          startPos.push(star2.y)
          startPos.push(star2.z)

          // head
          endPos.push(star.x - temp.x)
          endPos.push(star.y - temp.y)
          endPos.push(star.z - temp.z)
          // tail
          endPos.push(star2.x - temp.x)
          endPos.push(star2.y - temp.y)
          endPos.push(star2.z - temp.z)

          positions.push(star.x)
          positions.push(star.y)
          positions.push(star.z)

          positions.push(star2.x)
          positions.push(star2.y)
          positions.push(star2.z)

          // color.setHSL(1.0, 1.0, 1.0)
          // colors.push(color.r, color.g, color.b)

          // color.setHSL(0.5, 1.0, 0.1)
          // colors.push(color.r, color.g, color.b)

          randoms.push(rand)
          randoms.push(rand)

          tails.push(1)
          tails.push(0)

          // if (star.x < 0.01 && star.x > -0.01) {
          //   star.x = u
          // }
          // if (star.y < 0.01 && star.y > -0.01) {
          //   star.y = u
          // }

          // linesGeometry.vertices.push(star)
          // vertices.push(vertex.x, vertex.y, vertex.z )

          // normal
          // normal.set(vertex.x, vertex.y, vertex.z ).normalize()
          // normals.push(normal.x, normal.y, normal.z )

          // uv
          // uvs.push(u, 1 - v)
          // verticesRow.push(index++)
        }

        linesGeometry.addAttribute('startPos', new THREE.Float32BufferAttribute(startPos, 3))
        linesGeometry.addAttribute('endPos', new THREE.Float32BufferAttribute(endPos, 3))

        linesGeometry.addAttribute('position', new THREE.Float32BufferAttribute(positions, 3))
        // linesGeometry.addAttribute('color', new THREE.Float32BufferAttribute(colors, 3))

        // linesGeometry.addAttribute('random', new THREE.Float32BufferAttribute(randoms, 1).setDynamic(true))
        linesGeometry.addAttribute('random', new THREE.Float32BufferAttribute(randoms, 1))
        linesGeometry.addAttribute('tail', new THREE.Float32BufferAttribute(tails, 1))
        linesGeometry.computeBoundingSphere()

        // grid.push(verticesRow )
      }
    }

    this.makeSpiralGeo()
    shootingStarsField.geometry = linesGeometry
    shootingStarsField.needsUpdate = true

    var starsMaterial = new THREE.ShaderMaterial({
      vertexShader: require('./points-shader/vertex.vert'),
      fragmentShader: require('./points-shader/fragment.frag'),
      transparent: true,
      depthWrite: false,
      defines: {
        USE_MAP: '',
        USE_SIZEATTENUATION: ''
      },
      uniforms: {
        diffuse: { value: new THREE.Color(0xe2d9c2) },
        opacity: { value: 1.0 },
        time: { value: 1.0 },
        size: { value: window.parseFloat(this.size) },
        scale: { value: 1000.0 },
        map: { value: new THREE.TextureLoader().load(this.texture) },
        uvTransform: { value: new THREE.Matrix3() }// ,
        // // fog
        // fogDensity: { value: 0.00025 },
        // fogNear: { value: 1 },
        // fogFar: { value: 2000 },
        // fogColor: { value: new THREE.Color(0xffffff) }
      }
    })

    this.starsMaterial = starsMaterial

    shootingStarsField.material = starsMaterial
    shootingStarsField.material.needsUpdate = true

    this.$emit('element', this)
    this.$parent.$emit('add', shootingStarsField)
    this.clean = () => {
      this.$parent.$emit('remove', shootingStarsField)
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Parts/ShootingStarsField/ShootingStarsField.vue